import { FilterOptionOption } from 'react-select';
import CustomReactSelect from './custom-react-select';
import { reactSelectAdminStyles } from './react-select-styles';

const styleMap = {
  inline: reactSelectAdminStyles({
    menuPortal: () => ({ zIndex: 1100 }),
    control: () => ({
      padding: 0,
      paddingLeft: 0,
      border: 'none',
      margin: 0,
      minHeight: 'fit-content',
    }),
    placeholder: () => ({ padding: 0, margin: 0 }),
    valueContainer: () => ({ padding: 0, margin: 0 }),
    dropdownIndicator: () => ({ marginLeft: 2, padding: 0, width: 16, color: 'var(--gray-400)' }),
    singleValue: () => ({ padding: 0 }),
    input: () => ({ padding: 0, width: '100%', marginLeft: 0 }),
    menu: () => ({
      width: 254,
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    }),
    menuList: () => ({
      maxHeight: 254,
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    }),
    option: () => ({
      fontSize: '12px',
      padding: '8px 16px',
    }),
  }),
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface Props<T = any> {
  options: { label: string; value: T }[];
  onChange: (selected: unknown) => void;
  value: T;
  placeholder?: string;
  styles?: ReturnType<typeof reactSelectAdminStyles>;
  type?: keyof typeof styleMap;
  menuPortal?: boolean;
  filterOption?: ((option: FilterOptionOption<unknown>, inputValue: string) => boolean) | undefined;
}

export default function BasicSelectInput(props: Props) {
  return (
    <CustomReactSelect
      isMulti={false}
      styles={props.styles || (props.type ? styleMap[props.type] : undefined)}
      tabSelectsValue={false}
      closeMenuOnSelect={true}
      // menuIsOpen={true} // uncomment to keep the menu open and debug styles
      placeholder={props.placeholder}
      className="S2"
      classNames={{
        option: () => 'S2',
      }}
      options={props.options}
      onChange={props.onChange}
      menuPortalTarget={props.menuPortal ? document.body : undefined}
      value={props.value}
      filterOption={props.filterOption}
    />
  );
}
